import { AVATAR_BACKGROUND_COLOR_THEME_KEY, AVATAR_ICON_COLOR_THEME_KEY, DEFAULT_AVATAR_TYPES } from '../../Constants';
import { BreezeSvg } from './BreezeSvg';
import { CampaignSvg } from './CampaignSvg';
import { CompanySvg } from './CompanySvg';
import { ContactSvg } from './ContactSvg';
import { DealsSvg } from './DealsSvg';
import { ProductSvg } from './ProductSvg';
import { TicketSvg } from './TicketSvg';
export const DEFAULT_COLORS = {
  iconColor: AVATAR_ICON_COLOR_THEME_KEY,
  backgroundColor: AVATAR_BACKGROUND_COLOR_THEME_KEY
};
export const TRELLIS_DEFAULT_COLORS = {
  iconColor: 'icon-core-subtle',
  backgroundColor: 'specialty-table-header-hover'
};
export const DEFAULT_ICON_MAP = {
  [DEFAULT_AVATAR_TYPES.AI_AGENT]: BreezeSvg,
  [DEFAULT_AVATAR_TYPES.CAMPAIGN]: CampaignSvg,
  [DEFAULT_AVATAR_TYPES.CONTACT]: ContactSvg,
  [DEFAULT_AVATAR_TYPES.COMPANIES]: CompanySvg,
  [DEFAULT_AVATAR_TYPES.PRODUCT]: ProductSvg,
  [DEFAULT_AVATAR_TYPES.TICKET]: TicketSvg,
  [DEFAULT_AVATAR_TYPES.DEAL]: DealsSvg
};
export const DEFAULT_ICON_COLOR_MAP = {
  [DEFAULT_AVATAR_TYPES.AI_AGENT]: {
    // breeze-icon-secondary-default is in the theme, however not on the type.
    iconColor: 'breeze-icon-secondary-default',
    backgroundColor: 'fill-accent-magenta-subtle-alt'
  },
  [DEFAULT_AVATAR_TYPES.CAMPAIGN]: TRELLIS_DEFAULT_COLORS,
  [DEFAULT_AVATAR_TYPES.CONTACT]: TRELLIS_DEFAULT_COLORS,
  [DEFAULT_AVATAR_TYPES.COMPANIES]: TRELLIS_DEFAULT_COLORS,
  [DEFAULT_AVATAR_TYPES.PRODUCT]: TRELLIS_DEFAULT_COLORS,
  [DEFAULT_AVATAR_TYPES.TICKET]: TRELLIS_DEFAULT_COLORS,
  [DEFAULT_AVATAR_TYPES.DEAL]: TRELLIS_DEFAULT_COLORS
};